import React from 'react';
import { useFormikContext, useField } from 'formik';
import RawInputHhMm from '../../inputs/InputHhMm';

type InputHhMmProps = {
  name: string;
};

const InputHhMm = ({ name, ...rest }: InputHhMmProps) => {
  const { setFieldValue } = useFormikContext();
  const [field, meta] = useField(name);
  return (
    <RawInputHhMm
      {...meta}
      {...rest}
      value={field.value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
        setFieldValue(field.name, event.target.value)
      }
    />
  );
};

export default InputHhMm;
